const APP_ID = process.env.FACEBOOK_APP_ID;
const CONFIG_ID = process.env.FACEBOOK_APP_CONFIG_ID;
const AUTH_REDIRECT_URL = new URL("/facebook-auth/redirect", process.env.HOST).toString();

export const getFacebookLoginUrl = (shopUrl, state = {}) => {
  const urlParams = {
    client_id: APP_ID,
    redirect_uri: AUTH_REDIRECT_URL,
    state: JSON.stringify({
      ...state,
      shopUrl,
    }),
    config_id: CONFIG_ID,
    response_type: "code",
  };

  return `https://www.facebook.com/v20.0/dialog/oauth?${new URLSearchParams(urlParams).toString()}`;
};
